/**
 * Returns the height of the sticky header plus a small margin,
 * so react-joyride's automatic scroll doesn't hide target elements
 * beneath the sticky header.
 */
export const getJoyrideScrollOffset = (): number => {
  const header = document.querySelector('.header-new-block');
  return header ? (header as HTMLElement).offsetHeight + 16 : 90;
};

